/* Copyright (c) 2017 Backpack Health LLC */

/* global window, document */

import React from 'react';

import { Grid } from '../../../components/Grid';
import PdfViewer from '../../../views/components/PdfViewer';

function calculatePdfHeight() {
  // height should be a little bigger than one page, so the deafult pdf viewer background is negligble
  const maxWidth = window.innerWidth < 400 ? window.innerWidth : window.innerWidth * 0.8;
  const widthHeightRatio = (256 / 180) * maxWidth;
  const maxHeight = Math.min((window.innerHeight - 80), widthHeightRatio);
  return {
    width: maxWidth,
    height: maxHeight,
  };
}

interface Props {
  previewUrl: string;
}

class ShareCardPdfPreview extends React.Component<Props, {}> {

  render() {
    const dim = calculatePdfHeight();
    return (
      <div>
      <Grid justifyContent="center" alignItems="center" height="90%">
        <div style={{ width: dim.width, top: '4%', margin: 'auto' }}>
          <PdfViewer
            path={this.props.previewUrl}
            style={{
              width: dim.width,
              height: dim.height,
              backgroundColor: '#525659',
              boxShadow: '0 2px 14px -1px rgba(0, 0, 0, 0.5)',
            }}
          />
        </div>
      </Grid>
      </div>
    );
  }
}

export default ShareCardPdfPreview;
